<template>
  <div
    class="spa-soft-progressbar"
    data-component="spa-soft-progressbar"
  >
    <div class="spa-soft-progressbar-wrapper">
      <div
        ref="statusMessage"
        role="status"
        class="sr-only"
      >
        <span v-if="currentStepMessage">{{ currentStepMessage }}</span>
      </div>
      <div class="spa-soft-progressbar-steps">
        <button
          v-for="step in updatedStepsData"
          :key="step.stepName"
          :ref="isActive(step.stepIntId, step.subStepIntId) ? 'activeStep' : null"
          type="button"
          class="spa-soft-progressbar-step"
          :class="isActive(step.stepIntId, step.subStepIntId) && 'active'"
          :disabled="isDisabled(step.stepIntId, step.subStepIntId)"
          @click="buttonAction(step)"
        >
          <span class="circle">{{ step.stepNumber }}</span>
          <span class="label">{{ tc(step.label) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { SPA_SOFT_ROUTE_NAMES } from '@components/07.spa-soft/spa-soft/routes/spa-soft-routes'

  export default {
    name: 'SpaSoftProgressBar',
    components: {
    },
    data: () => ({
      spaSoftStepsList: [],
      currentStepMessage: '',
    }),
    computed: {
      ...mapState('spaSoft', ['step']),
      ...mapGetters('auth', ['isAuthenticated']),
      ...mapGetters('spaSoft', ['getStep', 'getStepIndexByValue']),
      ...mapGetters('i18n', ['tc']),
      updatedStepsData() {
        const { isAuthenticated } = this
        return this.spaSoftStepsList.filter((step) => {
          if (isAuthenticated) return step.forLogged
          return step.forNonLogged
        })
      },
    },
    watch: {
      step: {
        immediate: true,
        handler() {
          this.$nextTick(() => {
            setTimeout(() => {
              const activeStep = this.spaSoftStepsList.find((s) => (
                this.isStepActive(s.stepIntId) || this.isSubStepActive(s.subStepIntId)
              ))
              if (activeStep) {
                this.currentStepMessage = this.getAriaLabel(activeStep)
                if (this.$refs.activeStep && this.$refs.activeStep[0]) {
                  this.$refs.activeStep[0].focus()
                }
              }
            }, 100)
          })
        }
      }
    },
    mounted() {
      this.configSpaSoftStepsList()
    },
    methods: {
      ...mapActions('spaSoft', ['goToStep', 'updateStep']),
      configSpaSoftStepsList() {
        this.spaSoftStepsList = [
          {
            stepName: SPA_SOFT_ROUTE_NAMES.SPA_SOFT_TREATMENTS_AND_DATE,
            stepIntId: this.getStepIndexByValue(SPA_SOFT_ROUTE_NAMES.SPA_SOFT_TREATMENTS_AND_DATE),
            stepNumber: 1,
            subStepName: SPA_SOFT_ROUTE_NAMES.SPA_SOFT_ITINERARY_SELECTION,
            subStepLabel: 'spaSoft.step1.itinerarySelection.title',
            // eslint-disable-next-line max-len
            subStepIntId: this.getStepIndexByValue(SPA_SOFT_ROUTE_NAMES.SPA_SOFT_ITINERARY_SELECTION),
            label: 'spaSoft.step1.guestTimeDateSelection.stepName',
            forLogged: true,
            forNonLogged: true,
          },
          {
            stepName: SPA_SOFT_ROUTE_NAMES.SPA_SOFT_CHECK_OUT,
            stepIntId: this.getStepIndexByValue(SPA_SOFT_ROUTE_NAMES.SPA_SOFT_CHECK_OUT),
            stepNumber: 2,
            label: 'spaSoft.step2.stepName',
            forLogged: true,
            forNonLogged: true,
          },
        ]
      },
      buttonAction(step) {
        const { stepName, stepIntId, subStepIntId } = step
        if (stepIntId === this.step) return
        if (subStepIntId === this.step) {
          this.$router.push({
            name: stepName,
            query: {
              ...this.$route.query,
            }
          }).then(() => {
            this.updateStep(stepName)
          })
        } else {
          this.goToStep(stepName)
        }
      },
      isActive(stepIntId, subStepIntId) {
        return this.isStepActive(stepIntId) || this.isSubStepActive(subStepIntId)
      },
      isStepActive(stepIntId) {
        return stepIntId === this.step
      },
      isSubStepActive(subStepIntId) {
        return subStepIntId === this.step
      },
      isDisabled(stepIntId, subStepIntId) {
        return stepIntId > this.step || subStepIntId > this.step
      },
      getAriaLabel(step) {
        let currentStepLabel = ''
        if (this.isStepActive(step.stepIntId)) {
          currentStepLabel = step.label
        } else if (this.isSubStepActive(step.subStepIntId)) {
          currentStepLabel = step.subStepLabel
        }
        return `${this.tc('accessibility.stepNumber', { number: step.stepNumber })}, ${this.tc(currentStepLabel)}, ${this.tc('accessibility.currentStep')}`
      }
    }
  }
</script>
